// frontend/src/KlaviyoProfileCleanup/StoresStillInvalid.jsx
// Every Local Store value that is not a corporate store: the values Klaviyo's invalid segment flags, and the values found on club
// members that match no store (a closed store's name slips past the segment's fixed list). Each gets a rule here; pass 1 applies it.
import React, { useState } from 'react';
import { useDebounced } from '../ItAssets/common';
import { kpcApi } from './apiClient';
import { Alert, Pill, useKpc, useList, ws } from './common';
import { PickStore, useSnapshotRefresh } from './invalidShared';

export default function StoresStillInvalid() {
  const { notify } = useKpc();
  const [q, setQ] = useState('');
  const dq = useDebounced(q);
  const { data, error, reload } = useList(() => kpcApi.invalid({ group: 'value', q: dq }), [dq]);
  const refresh = useSnapshotRefresh(data, reload, [dq]);
  const [dialog, setDialog] = useState(null);      // { rule: row }
  const [err, setErr] = useState('');
  const openDialog = (d) => { setErr(''); setDialog(d); };
  const act = async (fn, msg) => { setErr(''); try { await fn(); notify(msg); reload(); openDialog(null); } catch (e) { setErr(e.message); } };
  const rows = data ? data.rows : [];
  const members = rows.filter((r) => r.members);
  return (
    <div className="uh-card">
      <div className="uh-ia-tbar">
        <input className="uh-inp" style={{ minWidth: 240 }} placeholder="Search a value" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Search" />
        <span className="uh-sp" />
        <span className="uh-muted">{refresh.status}</span>
        {refresh.button}
      </div>
      <Alert>{error || (dialog ? '' : err) || refresh.message}</Alert>
      <div className="uh-card-b"><div className="uh-kpc-banner info">Local Store values that are not a corporate store. The first rows are what Klaviyo's “Utility - Invalid Local Stores” segment flags; the rows marked “club members” are values the nightly run found on club members that match no store, such as a closed store's name, which that segment does not catch. Adding a rule renames the value tonight; a club member with an order or pickup on record keeps the store that evidence names.</div></div>
      <div className="uh-kpc-scroll"><table className="uh-tbl">
        <thead><tr><th>Current value</th><th className="r">Profiles</th><th className="r">Clubs</th><th>Where it was found</th><th /></tr></thead>
        <tbody>{rows.map((r, i) => (
          <tr key={i}><td>{ws(r.value)}</td><td className="r uh-num">{Number(r.profiles).toLocaleString()}</td>
            <td className="r uh-num">{r.members ? Number(r.clubs).toLocaleString() : <span className="uh-faint">—</span>}</td>
            <td className="uh-muted">{r.members ? <><Pill tone="hold">club members</Pill> not a corporate store</> : <><Pill tone="bad">invalid segment</Pill> flagged by Klaviyo</>}</td>
            <td className="r"><button type="button" className="uh-btn slim" onClick={() => openDialog({ rule: r })}>Add rule</button></td></tr>
        ))}</tbody>
        {!data && !error && <tbody><tr><td colSpan={5}><div className="uh-empty">Loading…</div></td></tr></tbody>}
        {data && !rows.length && <tbody><tr><td colSpan={5}><div className="uh-empty">Every value is a corporate store. Refresh to take a new snapshot.</div></td></tr></tbody>}
      </table></div>
      {data && members.length > 0 && <div className="uh-card-b uh-muted">{members.reduce((n, r) => n + Number(r.profiles), 0).toLocaleString()} club members sit on {members.length} values that are not a corporate store.</div>}
      {dialog && dialog.rule && <PickStore value={dialog.rule.value} stores={(data && data.stores) || []} onClose={() => openDialog(null)} error={err}
        onSave={(store) => act(() => kpcApi.addRule({ from_value: dialog.rule.value, to_value: store, kind: 'other' }), 'Rule created')} />}
    </div>
  );
}
